export const formatDateToString = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString(undefined, {
        weekday: 'short',
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    });
};